import { format, fromUnixTime, isValid, parse } from 'date-fns';
import { appDateFormat } from './const';
import { formatMilitaryToAMPM } from './times';

export const formatUtcToLocalDateTime = (utcDateTime) => {
  if (!utcDateTime) return utcDateTime;

  const parsed = parse(utcDateTime, appDateFormat.FULL_DATE_TIME, new Date());

  if (!isValid(parsed)) return utcDateTime;

  const localDate = new Date(
    Date.UTC(
      parsed.getFullYear(),
      parsed.getMonth(),
      parsed.getDate(),
      parsed.getHours(),
      parsed.getMinutes(),
      parsed.getSeconds()
    )
  );

  return format(localDate, appDateFormat.FULL_DATE_TIME);
};

export const dateFromUnixToString = (unixDate, formatString) => {
  if (!formatString) {
    throw new Error('formatString is required');
  }

  if (unixDate && typeof unixDate === 'number') {
    // format unix to seconds
    return format(fromUnixTime(unixDate / 1000), formatString);
  }

  return null;
};

export const getPerformanceDateTime = (date, time, ampm = false) => {
  if (!date) return time;
  if (!time) return date;

  const preparedTime = ampm ? formatMilitaryToAMPM(time) : time;
  return `${date ? `${date};` : ''} ${preparedTime}`;
};
